const getters = {
    opportunities: (state) => state.opportunities,
    opportunityId: (state) => state.opportunityId,
    newOpportunity: (state) => state.newOpportunity,
    pipelines: (state) => state.pipelines,
    loading: state => state.loading
};

export default getters;